import { render, staticRenderFns } from "./fundingAgency.vue?vue&type=template&id=1ef6d14f&scoped=true"
import script from "./fundingAgency.vue?vue&type=script&lang=js"
export * from "./fundingAgency.vue?vue&type=script&lang=js"
import style0 from "./fundingAgency.vue?vue&type=style&index=0&id=1ef6d14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef6d14f",
  null
  
)

export default component.exports